module.exports = __webpack_public_path__ + "img/phone.ca5baf18.gif";